module.exports = __webpack_public_path__ + "d8f8190b5270cf913de39d754f0a9e7e.woff";